export default __webpack_public_path__ + "static/media/AppraisalPP4.f3d88027.jpg";